import React, { useEffect, useRef, useState } from "react";
/**
 * Reveals a string one character at a time to mimic live typing. Use it for playful
 * intros, hero text, or to suggest an agent is "typing" a short message, keeping `text`
 * concise so the reveal does not feel slow; for streaming model output that genuinely
 * arrives token-by-token, render the real tokens rather than this decorative effect.
 *
 * @summary Character-by-character typing effect.
 */
export function TypingAnimation({ text, duration = 50, onComplete, }) {
    const [displayedText, setDisplayedText] = useState(text.substring(0, 1));
    // Start at one to avoid an empty text as first display as it sometimes shrinks the container.
    const [i, setI] = useState(Math.min(1, text.length));
    const onCompleteRef = useRef(onComplete);
    onCompleteRef.current = onComplete;
    useEffect(() => {
        const typingEffect = setInterval(() => {
            var _a;
            if (i < text.length) {
                setDisplayedText(text.substring(0, i + 1));
                setI(i + 1);
            }
            else {
                clearInterval(typingEffect);
                (_a = onCompleteRef.current) === null || _a === void 0 ? void 0 : _a.call(onCompleteRef);
            }
        }, duration);
        return () => {
            clearInterval(typingEffect);
        };
    }, [duration, i, text]);
    return React.createElement("span", { className: "notranslate" }, displayedText);
}
//# sourceMappingURL=TypingAnimation.js.map